module.exports = __webpack_public_path__ + "img/rocket.b65220b1.gif";